<template>
	<div class="section-question">
		<v-layout wrap class="container">
			<v-flex xs12 md1 class="wrapper-logo">
				<img 
					:src="`${$S3}logo-min.svg`" 
					alt="logo"
					height="58">
			</v-flex>
			<v-flex xs12 md11>
				<p class="mb-0 title">PREGUNTAS FRECUENTES</p>
			</v-flex>
		</v-layout>
		<v-layout wrap class="container">
			<v-flex xs12 md5 class="pr-24">
				<div class="section-title">
					¿Cuál es el costo de tener mi propio Aplicativo?
				</div>
				<div class="section-text">
					Tener tu propia app de pedidos con una mínima inversión.
					Déjanos tus datos <a :href="hrefHere" class="href-here">aquí</a> para que un asesor de ventas se comunique
					contigo y pueda darte todo el detalle del servicio.
				</div>
			</v-flex>
			<v-flex xs12 md7 class="pl-24">
				<div class="section-title">
					¿Qué puedo vender con MiBodega?
				</div>
				<div class="section-text">
					Puedes vender lo que quieras en el rubro que desees, recuerda que es tu negocio y hemos creado un aplicativo
					que se adapta a ti.
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="container">
			<v-flex xs12 md5 class="pr-24">
				<div class="section-title">
					¿El servicio es a nivel nacional?
				</div>
				<div class="section-text">
					Si, puedes contratar nuestro servicio a nivel nacional.
					MiBodega funciona en todo el país.
				</div>
			</v-flex>
			<v-flex xs12 md7 class="pl-24">
				<div class="section-title">
					¿Qué pasa si no cuente con el servicio de delivery?
				</div>
				<div class="section-text">
					No hay problema, MiBodega se adapta a tu negocio y solo ofrecerás el servicio de "pago en efectivo".
					En el momento que decías incluir el servicio de pago online lo incluimos en tu aplicativo, ya que estamos
					preparados para ofrecerlo. El contrato con las plataformas de pago online es directamente con el dueño del negocio.
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="container">
			<v-flex xs12 md5 class="pr-24">
				<div class="section-title">
					¿Qué pasa si tengo más de un local?
				</div>
				<div class="section-text">
					Excelente, con MiBodega puedes gestionar todas los negocios que tengas.
					Déjanos tus datos <a :href="hrefHere" class="href-here">aquí</a> para que
					un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.
				</div>
			</v-flex>
			<v-flex xs12 md7 class="pl-24">
				<div class="section-title">
					¿Qué pasa si no cuento con el servicio de pago online?
				</div>
				<div class="section-text">
					No hay problema, MiBodega se adapta a tu negocio y solo ofrecerás el servicio de "pago en efectivo".
					En el momento que decías incluir el servicio de pago online lo incluimos en tu aplicativo, ya que
					estamos preparados para ofrecerlo. El contrato con las plataformas de pago online es directamente
					con el dueño del negocio.
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="container">
			<v-flex xs12 md5 class="pr-24">
				<div class="section-title">
					¿En cuánto tiempo me entregan el aplicativo?
				</div>
				<div class="section-text">
					Depende cuán rápido efectúes el pago y coordinemos toda la información de tu negocio,
					pero es un promedio de 2 semanas como máximo.
				</div>
			</v-flex>
			<v-flex xs12 md7 class="pl-24">
				<div class="section-title">
					¿Cómo funcionan los Pedicréditos?
				</div>
				<div class="section-text">
					Es muy sencillo y hemos pensado la manera más conveniente para negocio.
					Sólo debes precargar tu aplicativo con el monto que deseas y este se descontará
					de cada pedido generado. Por ejemplo, si recargas {{ currencySymbol }}{{ creditValue }}
					de "Pedicréditos" ese dinero te alcanza para la comisión de 5 pedidos de
					{{ currencySymbol }}{{ fiveOrders | round }} {{ centLabel }} cada uno. En el caso que no hayas
					hecho la recarga de "Pedicréditos" y un cliente haga un pedido, te avisamos para que recargues
					y no pierdas la venta. El monto mínimo de recarga es de {{ currencySymbol }}{{ minValue }}.
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="container">
			<v-flex xs12 md5 class="pr-24">
				<div class="section-title">
					¿Quién determina el precio del producto?
				</div>
				<div class="section-text">
					Tú, como dueño de tu negocio. Es muy sencillo de hacerlo: Ingresando a tu administrador
					podrás ingresar los precios de tus productos y definir los precios de los mismos.
				</div>
			</v-flex>
			<v-flex xs12 md7 class="pl-24">
				<div class="section-title">
					¿MiBodega trabaja con otro tipo de negocios, como restaurantes o lavanderías?
				</div>
				<div class="section-text">
					Si, ponemos a disposición de otras industrias el aplicativo para que puedan hacer crecer su negocio.
					En caso desees más información, déjanos tus datos <a :href="hrefHere" class="href-here">aquí</a> para
					que un asesor de ventas se comunique contigo y pueda darte todo el detalle del servicio.
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
function centLabel() {
	return this.isPeru ? 'céntimos' : 'centavos';
}

function currencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function fiveOrders() {
	return this.creditValue / 5;
}

function hrefHere() {
	return this.isPeru ? 'https://registro.mibodega.net/' : 'https://registro-ec.mibodega.net/';
}

function data() {
	return {
		creditValue: process.env.CREDIT_VALUE,
		minValue: 20,
	};
}

export default {
	name: 'section-question',
	computed: {
		centLabel,
		currencySymbol,
		fiveOrders,
		hrefHere,
	},
	data,
};
</script>
<style lang="scss" scoped>
	.section-question {
		padding: 75px 7% 25px 7%;

		@media (max-width: 936px) {
			padding: 30px 0;
		}
	}

	.title {
		color: color(green-dark);
		font-size: size(large30) !important;
		font-weight: weight(w900) !important;
		margin-bottom: 60px !important;
		padding-top: 15px;

		@media (max-width: 936px) {
			font-size: size(large) !important;
			margin-bottom: 30px !important;
			text-align: center;
		}
	}

	.section-title {
		background-color: color(faq-background);
		color: color(green-dark);
		font-weight: 600;
		padding: 8px 12px;

		@media (max-width: 936px) {
			text-align: center;
		}
	}

	.section-text {
		color: color(form-grey);
		font-size: size(medium);
		margin-bottom: 10px;
		margin-left: 11px;

		@media (max-width: 936px) {
			margin-bottom: 10px;
			min-height: auto;
			text-align: center;
		}
	}

	.wrapper-logo {
		@media (max-width: 936px) {
			text-align: center;
		}
	}

	.pr-24 {
		padding-right: 24px;

		@media (max-width: 936px) {
			padding-right: 0;
		}
	}

	.pl-24 {
		padding-left: 24px;

		@media (max-width: 936px) {
			padding-left: 0;
		}
	}

	.href-here {
		color: color(title-green);
		font-size: size(medium);
		font-weight: weight(w700);
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-question.vue